
define('text!modules/T1App/edit/team/templates/bin.html',[],function () { return '<div class="bin-header"><strand-icon class="icon" type="include" width="16" height="16"></strand-icon> Development Team</div>\n<div class="dev-team-container"></div>';});

